import { ILocale, defaultLocale, isDefaultLocale } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";

export const useTermDictionaryColumnNames = (locale: ILocale = {} as ILocale, bilingual?: boolean, reversed?: boolean) => {
  const localizedValues = useLocalizedValues(() => ({
    defaultLocaleName: {
      value: defaultLocale.name
    },
    industrySpecific: glossaryMessages.property("industrySpecific")
  }));

  const columnNames: string[] = [];
  const index = reversed ? 1 : 0;

  if (bilingual) {
    columnNames[index] = localizedValues.defaultLocaleName;
    columnNames[index ^ 1] = isDefaultLocale(locale.localeIdentifier) ? columnNames[index] + ` (${localizedValues.industrySpecific})` : locale.name;
  } else {
    columnNames[0] = locale.name;
  }

  return columnNames;
};
